<template>
  <div>
    <Modal
      v-model="modal"
      :title="
        !elasticsearchWarningForm.id
          ? this.$t('alarms.elasticSearch.addEsAlarm')
          : this.$t('alarms.elasticSearch.editEsAlarm')
      "
      @on-cancel="cancel"
      @on-ok="ok"
      :loading="loading"
      :mask-closable="false"
      :styles="{ top: '65px' }"
      width="800px"
      :footer-hide="true"
      :closable="false"
    >
      <Form
        ref="elasticsearchWarningForm"
        :model="elasticsearchWarningForm"
        :label-width="110"
        :rules="ruleValidate"
      >
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning
            v-if="wechatWarningVisible"
            ref="wechatWarning"
          ></wechat-warning>
          <!-- 规则名称 -->
          <FormItem
            :label="$t('alarms.common.ruleName')"
            prop="ruleName"
            v-if="isEditRuleName"
          >
            <Row>
              <Col span="11">
                <Input
                  type="text"
                  v-model="elasticsearchWarningForm.ruleName"
                  placeholder="Enter something..."
                  style="width: 300px"
                  :disabled="isEdit"
                ></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>{{ this.elasticsearchWarningForm.ruleName }}</div>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="$t('alarms.common.ruleDescription')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="6">
                <FormItem prop="monitorIndex">
                  <Select
                    v-model="elasticsearchWarningForm.monitorIndex"
                    filterable
                    @on-change="
                      changeMonitorIndex(elasticsearchWarningForm.monitorIndex)
                    "
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="item in monitorIndexList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select
                    v-model="elasticsearchWarningForm.cycle"
                    filterable
                    :placeholder="$t('alarms.common.cycle')"
                    @on-change="changeCycle(elasticsearchWarningForm.cycle)"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in cycleList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="4">
                <FormItem prop="continousCycle">
                  <Select
                    v-model="elasticsearchWarningForm.continousCycle"
                    filterable
                    :placeholder="$t('alarms.common.continuousCycle')"
                    @on-change="
                      changeContinousCycle(
                        elasticsearchWarningForm.continousCycle
                      )
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in continousCycleList"
                      v-bind:key="index"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="3">
                <FormItem prop="statisticsValue">
                  <Select
                    v-model="elasticsearchWarningForm.statisticsValue"
                    filterable
                    :placeholder="$t('alarms.common.statisticsValue')"
                    @on-change="
                      changeStatisticsValue(
                        elasticsearchWarningForm.statisticsValue
                      )
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in statisticsValueList"
                      v-bind:key="index"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <div v-if="this.isShowField">
                <!-- 关系符号 -->
                <Col span="2">
                  <FormItem prop="relationshipSign">
                    <Select
                      v-model="elasticsearchWarningForm.relationshipSign"
                      filterable
                      @on-change="
                        changeRelationshipSign(
                          elasticsearchWarningForm.relationshipSign
                        )
                      "
                      :placeholder="$t('alarms.common.symbol')"
                    >
                      <Option
                        :value="item.id"
                        v-for="(item, index) in relationshipSignList"
                        v-bind:key="index"
                      >{{ item.name }}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input
                      v-model="elasticsearchWarningForm.thresholdValue"
                      :placeholder="$t('alarms.common.threshold')"
                      type="number"
                    ></Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input
                      v-model="elasticsearchWarningForm.unit"
                      disabled
                      :placeholder="$t('alarms.common.unit')"
                    ></Input>
                  </FormItem>
                </Col>
              </div>
            </Row>
          </FormItem>

          <!-- 联系方式 -->
          <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
            <RadioGroup
              v-model="elasticsearchWarningForm.contactType"
              @on-change="
                changeContactType(elasticsearchWarningForm.contactType)
              "
            >
              <Radio
                v-for="item in contactTypeList"
                :label="item.type"
                :key="item.value"
                >{{ item.label }}</Radio
              >
            </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem
            :label="$t('alarms.common.notificationObject')"
            prop="notificationObject"
            v-if="elasticsearchWarningForm.contactType == 0"
          >
            <Select
              v-model="elasticsearchWarningForm.notificationObject"
              filterable
              multiple
              style="width: 300px"
              @on-change="changeNotificationObject"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in notificationObjectList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 联系人组 -->
          <FormItem
            :label="$t('alarms.common.contactGroup')"
            prop="contactGroupIds"
            v-if="elasticsearchWarningForm.contactType == 1"
          >
            <Select
              v-model="elasticsearchWarningForm.contactGroupIds"
              filterable
              multiple
              style="width: 300px"
              @on-change="
                changeContactGroupId(elasticsearchWarningForm.contactGroupIds)
              "
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in contactGroupIdList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
            <Select
              v-model="elasticsearchWarningForm.noticeType"
              filterable
              multiple
              style="width: 300px"
              @on-change="selectNoticeType(elasticsearchWarningForm.noticeType)"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmWayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem
            :label="$t('alarms.common.enterpriseWeChatRobotURL')"
            prop="enterpriseWechatRobotIds"
            v-if="
              elasticsearchWarningForm.noticeType.filter(function (e) {
                return e == 3;
              }).length != 0
            "
          >
            <Select
              v-model="elasticsearchWarningForm.enterpriseWechatRobotIds"
              filterable
              multiple
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in enterpriseWechatRobotIdsList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
            <Select
              v-model="elasticsearchWarningForm.alarmDelay"
              filterable
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmDelayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 监控时段 -->
          <FormItem
            :label="$t('alarms.common.monitorPeriod')"
            prop="monitorPeriod"
          >
            <Select
              v-model="elasticsearchWarningForm.monitorPeriod"
              filterable
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in monitorPeriodList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
              <Input
                v-model="elasticsearchWarningForm.emailModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>
          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem
              :label="$t('alarms.common.wechatModal')"
              prop="wechatModal"
            >
              <Input
                v-model="elasticsearchWarningForm.wechatModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              style="float: right"
              @click="ok('elasticsearchWarningForm')"
              :loading="addloading"
              :disabled="isAddOrEdit"
            >
              {{
                !elasticsearchWarningForm.id
                  ? this.$t("common.addAlarm")
                  : this.$t("common.editAlarm")
              }}
            </Button>
            <Button
              size="large"
              style="float: right; margin-right: 10px"
              @click="cancel('elasticsearchWarningForm')"
              >{{ $t("alarms.common.cancel") }}
            </Button>
            <Button
              size="large"
              @click="previousPage"
              style="float: right; margin-right: 10px"
              >{{ $t("alarms.common.lastStep") }}</Button
            >
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="8">
                <!-- 账户 -->
                <FormItem
                  :label="$t('alarms.common.account')"
                  prop="account"
                  :label-width="50"
                >
                  <Select
                    v-model="elasticsearchWarningForm.account"
                    filterable
                    @on-change="changeAccount(elasticsearchWarningForm.account)"
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in accountList"
                      v-bind:key="index"
                      >{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="10" style="z-index: 200">
                <!-- 存储区域 -->
                <FormItem
                  :label="$t('alarms.common.region')"
                  prop="backupRegion"
                >
                  <Select
                    @on-change="
                      changebackupRegion(elasticsearchWarningForm.backupRegion)
                    "
                    v-model="elasticsearchWarningForm.backupRegion"
                    filterable
                    multiple
                    :max-tag-count="1"
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Checkbox
                      v-model="singleBackupRegion"
                      @on-change="selectBackupRegionAll"
                      style="display: block; text-align: right"
                      >{{ $t("alarms.common.allSelected") }}</Checkbox
                    >
                    <Option
                      :value="item.name"
                      v-for="item in backupRegionList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Button
                type="primary"
                style="float: right"
                v-show="isShowSearch"
                @click="searchElasticsearchDate"
                >{{ $t("alarms.common.search") }}</Button
              >
            </Row>
          </div>

          <v-table
            :height="459"
            column-width-drag
            is-horizontal-resize
            style="width: 100%; height: 459px; margin-bottom: 15px"
            :columns="column"
            :table-data="tableElasticsearchDate"
            row-hover-color="#edf7ff"
            :is-loading="modal_loadings"
            title-bg-color="#f8f8f9"
            :select-group-change="selectChange"
            :select-all="selectAll"
          ></v-table>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              @click="nextPage"
              style="float: right"
              :disabled="isNextClick"
              >{{ $t("alarms.common.nextStep") }}
            </Button>
            <Button
              size="large"
              style="margin-right: 10px; float: right"
              @click="cancel('elasticsearchWarningForm')"
              >{{ $t("alarms.common.cancel") }}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import WechatWarning from "../common/WechatWarning.vue";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableElasticsearch from "../es/TableElasticsearch.vue";

var tableElasticsearch = TableElasticsearch;
var tableElasticsearchWarningVue = {};
export default {
  inject: ["reload"],
  components: {
    WechatWarning,
  },
  data() {
    // 名字是否重复
    var validNameRepeatedCheck = (rule, value, callback) => {
      var self = this;
      self.$api.alertRule
        .nameRepeatedCheck({
          alertRuleName: this.elasticsearchWarningForm.ruleName,
          monitorModule: this.monitorModule,
        })
        .then((res) => {
          if (res.status == 200) {
            callback();
          }
        })
        .catch((err) => {
          if (err.status == 400) {
            callback(new Error("规则名称不能重复!"));
          }
        });
    };
    return {
      monitorModule: 14,
      isAddOrEdit: true,
      wechatWarningVisible: false,
      contactTypeList: [
        {
          label: this.$t("alarms.common.contactPerson"),
          value: "contact",
          type: 0,
        },
        {
          label: this.$t("alarms.common.contactGroup"),
          value: "contactGroup",
          type: 1,
        },
      ],
      isShowField: true, //是否显示符号、阈值和单位
      addloading: false,
      singleBackupRegion: false,
      alarmDelayList: [],
      monitorPeriodList: [],
      isEdit: false,
      isShowSearch: false,
      isEditRuleName: false,
      showRuleName: false,
      modal_loadings: false,
      isShowEmail: false,
      isShowWeChat: false,
      isNext: false,
      isPrevious: true,
      selection: [],
      accountList: [],
      notificationObjectList: [],
      alarmWayList: [],
      backupRegionList: [],
      loading: true,
      modal: false,
      modal_loading: false,
      exportDataList: "",
      noticeType: [],
      units: "",
      isNextClick: true, //禁止点击下一步
      unit: "",
      elasticsearchWarningForm: {
        account: "",
        ruleName: "",
        notificationObject: [],
        noticeType: [],
        emailModal: "",
        wechatModal: "",
        thresholdValue: "",
        monitorIndex: "",
        cycle: "",
        continousCycle: "",
        statisticsValue: "",
        relationshipSign: "",
        unit: "",
        backupRegion: [],
        alarmDelay: "",
        monitorPeriod: "",
        contactType: 0,
        contactGroupIds: [],
        userIdList: [],
        enterpriseWechatRobotIds: [],
      },
      enterpriseWechatRobotIdsList: [],
      // 联系人组
      contactGroupIdList: [],
      // 监控指标
      monitorIndexList: [],
      // 周期
      cycleList: [],
      // 连续周期
      continousCycleList: [],
      // 统计数值
      statisticsValueList: [],
      // 关系符号
      relationshipSignList: [],
      ruleValidate: {
        account: [
          {
            required: true,
            message: "请选择账户名称",
            trigger: "change",
            type: "number",
          },
        ],
        alarmDelay: [
          {
            required: true,
            message: "请选择延迟告警",
            trigger: "change",
            type: "number",
          },
        ],
        monitorPeriod: [
          {
            required: true,
            message: "请选择监控时段",
            trigger: "change",
            type: "number",
          },
        ],
        backupRegion: [
          {
            required: true,
            type: "array",
            message: "请选择存储区域",
            trigger: "change",
          },
        ],
        ruleName: [
          { required: true, message: "规则名称不能为空", trigger: "blur" },
          {
            type: "string",
            message: "规则名称为2-20个字符首尾中间不能有空格",
            pattern: "^[^ ]{2,20}$",
            trigger: "blur",
          },
          { validator: validNameRepeatedCheck, trigger: "blur" },
        ],
        notificationObject: [
          {
            required: true,
            type: "array",
            message: "请选择通知对象",
            trigger: "change",
          },
        ],
        noticeType: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请选择报警方式",
            trigger: "change",
          },
        ],
        monitorIndex: [
          {
            required: true,
            message: "请选择监控指标",
            trigger: "change",
            type: "number",
          },
        ],
        cycle: [
          {
            required: true,
            message: "请选择周期",
            trigger: "change",
            type: "number",
          },
        ],
        continousCycle: [
          {
            required: true,
            message: "请选择连续周期",
            trigger: "change",
            type: "number",
          },
        ],
        statisticsValue: [
          {
            required: true,
            message: "请选择统计数值",
            trigger: "change",
            type: "number",
          },
        ],
        relationshipSign: [
          {
            required: true,
            message: "请选择关系符号",
            trigger: "change",
            type: "number",
          },
        ],
        thresholdValue: [{ required: true, message: "请输入阈值" }],
        contactType: [
          {
            required: true,
            message: "请选择联系方式",
            trigger: "change",
            type: "number",
          },
        ],
        contactGroupIds: [
          {
            required: true,
            message: "请选择联系人组",
            trigger: "change",
            type: "array",
          },
        ],
        enterpriseWechatRobotIds: [
          {
            required: true,
            type: "array",
            message: "请选择企业微信机器人URL",
            trigger: "change",
          },
        ],
      },
      column: [
        {
          width: 60,
          titleAlign: "center",
          columnAlign: "center",
          type: "selection",
        },
        {
          field: "domainName",
          title: this.$t("alarms.elasticSearch.esDomain"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
        {
          field: "region",
          title: this.$t("alarms.common.region"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
      ],
      tableElasticsearchDate: [],
      newTableElasticsearchDateList: [],
      esList: [],
      compareElasticsearchList: [],
    };
  },

  beforeCreate: function () {
    tableElasticsearchWarningVue = this;
  },
  methods: {
    //显示表格数据
    /****************************************************************/
    // 下一步
    nextPage: function () {
      this.isNext = true;
      this.isPrevious = false;
      // 查询监控指标
      tableElasticsearchWarningVue.searchMonitorIndex();
      // 查询阈值
      tableElasticsearchWarningVue.selectMonitorIndexDefault();
      // 查询联系人组
      tableElasticsearchWarningVue.listContactGroups();
    },
    // 上一步
    previousPage: function () {
      this.isNext = false;
      this.isPrevious = true;
    },
    init: function (id) {
      this.elasticsearchWarningForm.id = id || 0;
      // 根据用户名查询Account列表
      tableElasticsearchWarningVue.getAccount();
      this.$nextTick(() => {
        // 重置表单
        this.$refs["elasticsearchWarningForm"].resetFields();
        // 编辑
        if (this.elasticsearchWarningForm.id) {
          // 编辑显示不能输入的规则名称
          this.showRuleName = true;
          this.isEdit = true;
          this.isShowSearch = false;
          this.$api.alertRule
            .selectAlertRule("id", this.elasticsearchWarningForm.id)
            .then((res) => {
              //延时
              this.elasticsearchWarningForm.alarmDelay = res.data.delay;
              //监控时段
              this.elasticsearchWarningForm.monitorPeriod =
                res.data.monitorPeriod;
              // 账户
              /******************************************************/
              this.elasticsearchWarningForm.account = res.data.accountId;
              tableElasticsearchWarningVue.$api.account
                .queryAccountRegions(
                  "accountId",
                  this.elasticsearchWarningForm.account
                )
                .then((res) => {
                  this.backupRegionList = res.data;
                });

              tableElasticsearchWarningVue.$api.contact
                .queryContactsByAccountIdAndMonitorModule({
                  monitorModule: this.monitorModule,
                  accountId: this.elasticsearchWarningForm.account,
                })
                .then((res) => {
                  this.notificationObjectList = res.data.contactList;
                });

              this.modal_loadings = true;

              setTimeout(() => {
                // 存储区域
                this.elasticsearchWarningForm.backupRegion = res.data.regions;

                // es列表
                /******************************************************/
                this.esList = res.data.resourceEsDTOList;

                this.compareElasticsearchList = res.data.resourceEsDTOList;
                // 根据AccountId查询es列表
                tableElasticsearchWarningVue.$api.elasticsearch
                  .listEsByAccount({
                    regions: this.elasticsearchWarningForm.backupRegion,
                    accountId: this.elasticsearchWarningForm.account,
                  })
                  .then((res) => {
                    this.tableElasticsearchDate = res.data;
                    this.modal_loadings = false;
                    for (
                      var i = 0;
                      i < this.tableElasticsearchDate.length;
                      i++
                    ) {
                      for (
                        var j = 0;
                        j < this.compareElasticsearchList.length;
                        j++
                      ) {
                        if (
                          this.tableElasticsearchDate[i].domainName ==
                          this.compareElasticsearchList[j].domainName
                        ) {
                          this.tableElasticsearchDate[i]._checked = true;
                        }
                      }
                    }
                    // 选了数据 可以点击下一步
                    if (
                      this.tableElasticsearchDate.length == 0 ||
                      this.compareElasticsearchList.length == 0
                    ) {
                      this.isNextClick = true;
                    } else {
                      this.isNextClick = false;
                    }
                  });
              }, 1000);

              this.newTableElasticsearchDateList = res.data.resourceEsDTOList;

              // 规则名称
              this.elasticsearchWarningForm.ruleName = res.data.alertRuleName;

              // 监控指标
              /******************************************************/
              this.elasticsearchWarningForm.monitorIndex =
                res.data.monitorIndex;
              // 判断状态
              this.judgeState();
              // 周期
              this.elasticsearchWarningForm.cycle = res.data.cycle;
              // 连续周期
              this.elasticsearchWarningForm.continousCycle =
                res.data.continousCycle;
              // 统计数值
              this.elasticsearchWarningForm.statisticsValue =
                res.data.statisticsValue;
              // 符号
              this.elasticsearchWarningForm.relationshipSign =
                res.data.relationshipSign;
              // 阈值
              this.elasticsearchWarningForm.thresholdValue =
                res.data.thresholdValue;
              // 单位
              this.elasticsearchWarningForm.unit = res.data.unit;
              this.units = res.data.unitId;
              // 企业微信机器人URL
              this.elasticsearchWarningForm.enterpriseWechatRobotIds =
                res.data.enterpriseWechatRobotIds;

              // 联系方式
              this.elasticsearchWarningForm.contactType = res.data.contactType;
              if (res.data.contactType == 0) {
                // 通知对象
                this.elasticsearchWarningForm.notificationObject =
                  res.data.contactIDs;
                for (
                  var i = 0;
                  i < this.elasticsearchWarningForm.notificationObject.length;
                  i++
                ) {
                  for (var j = 0; j < this.notificationObjectList.length; j++) {
                    if (
                      this.elasticsearchWarningForm.notificationObject[i] ==
                      this.notificationObjectList[j].id
                    ) {
                      this.elasticsearchWarningForm.userIdList.push(
                        this.notificationObjectList[j].userId
                      ); //传值
                    }
                  }
                }
              } else if (res.data.contactType == 1) {
                // 联系人组
                this.$api.contactGroup
                  .listContactGroupsByAccountId(
                    "accountId",
                    this.elasticsearchWarningForm.account
                  )
                  .then((res) => {
                    this.contactGroupIdList = res.data;
                  });
                setTimeout(() => {
                  this.elasticsearchWarningForm.contactGroupIds =
                    res.data.contactGroupIds;
                }, 1000);
              }

              // 报警方式
              this.elasticsearchWarningForm.noticeType = res.data.noticeType;
              // 循环邮件模板
              for (
                let i = 0;
                i < this.elasticsearchWarningForm.noticeType.length;
                i++
              ) {
                if (this.elasticsearchWarningForm.noticeType[i] === 0) {
                  this.isShowEmail = true;
                  this.elasticsearchWarningForm.emailModal =
                    res.data.briefReportBodyMail;
                  this.noticeType = this.elasticsearchWarningForm.noticeType;
                  tableElasticsearchWarningVue.selectTemplate();
                }
                if (this.elasticsearchWarningForm.noticeType[i] === 1) {
                  this.isShowWeChat = true;
                  this.elasticsearchWarningForm.wechatModal =
                    res.data.briefReportBodyWechat;
                  this.checkLeastOnePersonBoundWeChat();
                  this.noticeType = this.elasticsearchWarningForm.noticeType;
                  if (
                    !this.isNotEmpty(this.elasticsearchWarningForm.wechatModal)
                  ) {
                    tableElasticsearchWarningVue.selectTemplate();
                  }
                } else {
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = false;
                }
              }
            });
        } else {
          this.tableElasticsearchDate = [];
          this.isEdit = false;
          this.isShowSearch = true;
          // 添加显示规则名称能输入
          this.isEditRuleName = true;
          this.showRuleName = false;
        }
      });
      this.modal = true;
      this.isNext = false;
      this.isPrevious = true;
    },
    // 根据监控指标 显示不同单位
    /****************************************************************/
    // 清空周期、连续周期、统计数值、关系符号
    emptyDate: function () {
      this.elasticsearchWarningForm.cycle = "";
      this.elasticsearchWarningForm.continousCycle = "";
      this.elasticsearchWarningForm.statisticsValue = "";
      this.elasticsearchWarningForm.relationshipSign = "";
      this.elasticsearchWarningForm.thresholdValue = "";
    },
    isNotEmpty: function (obj) {
      if (typeof obj === "undefined" || obj === null || obj === "") {
        return false;
      } else {
        return true;
      }
    },
    // 判断状态
    judgeState: function () {
      // 如果监控指标为集群状态（黄色）、集群状态（红色）、主节点时 不显示符号、阈值和单位
      let metrics = [48, 49, 50, 69, 70, 72, 73, 74, 79, 80];
      if (metrics.includes(this.elasticsearchWarningForm.monitorIndex)) {
        this.isShowField = false;
      } else {
        this.isShowField = true;
      }
    },
    // 根据监控指标 显示不同单位
    changeMonitorIndex: function () {
      // 判断状态
      this.judgeState();
      tableElasticsearchWarningVue.selectMonitorIndexDefault();
      this.unit = this.elasticsearchWarningForm.monitorIndex;
      for (let i = 0; i < this.monitorIndexList.length; i++) {
        if (this.monitorIndexList[i].id === this.unit) {
          this.elasticsearchWarningForm.unit = this.monitorIndexList[i].unit;
          this.units = this.monitorIndexList[i].id;
        }
      }
      tableElasticsearchWarningVue.selectTemplate();
      tableElasticsearchWarningVue.emptyDate();
    },
    // 查询阈值
    /****************************************************************/
    selectMonitorIndexDefault: function () {
      if (
        this.elasticsearchWarningForm.account == "" ||
        this.elasticsearchWarningForm.account == null
      ) {
        return;
      }
      tableElasticsearchWarningVue.$api.alertRule
        .selectMonitorIndexDefault({
          monitorIndex: this.elasticsearchWarningForm.monitorIndex,
          monitorModule: this.monitorModule,
          cycle: this.elasticsearchWarningForm.cycle,
          continousCycle: this.elasticsearchWarningForm.continousCycle,
          statisticsValue: this.elasticsearchWarningForm.statisticsValue,
          relationshipSign: this.elasticsearchWarningForm.relationshipSign,
          accountId: this.elasticsearchWarningForm.account,
        })
        .then((res) => {
          // 周期
          this.cycleList = res.data.cycleMap;
          // 连续周期
          this.continousCycleList = res.data.continousCycleMap;
          // 统计数值
          this.statisticsValueList = res.data.statisticsValueMap;
          // 关系符号
          this.relationshipSignList = res.data.relationshipSignMap;
          // 阈值
          if (
            res.data.companyMonitoritemVariablesList.length == 1 &&
            tableElasticsearchWarningVue.isNotEmpty(
              this.elasticsearchWarningForm.cycle
            ) &&
            tableElasticsearchWarningVue.isNotEmpty(
              this.elasticsearchWarningForm.continousCycle
            ) &&
            tableElasticsearchWarningVue.isNotEmpty(
              this.elasticsearchWarningForm.statisticsValue
            ) &&
            tableElasticsearchWarningVue.isNotEmpty(
              this.elasticsearchWarningForm.relationshipSign
            ) &&
            this.elasticsearchWarningForm.id == 0
          ) {
            this.elasticsearchWarningForm.thresholdValue =
              res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
          }
        });
    },
    // 查询邮件模板
    /****************************************************************/
    selectTemplate: function () {
      tableElasticsearchWarningVue.$api.briefReport
        .selectTemplate({
          monitorIndex: this.elasticsearchWarningForm.monitorIndex,
          relationshipSign: this.elasticsearchWarningForm.relationshipSign,
          monitorModule: this.monitorModule,
          noticeType: this.elasticsearchWarningForm.noticeType,
        })
        .then((res) => {
          this.elasticsearchWarningForm.wechatModal =
            res.data.briefReportBodyWechat;
          this.elasticsearchWarningForm.emailModal =
            res.data.briefReportBodyMail;
        });
    },
    //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
    selectNoticeType: function () {
      this.isShowEmail = false;
      this.isShowWeChat = false;
      for (
        let i = 0;
        i < this.elasticsearchWarningForm.noticeType.length;
        i++
      ) {
        if (this.elasticsearchWarningForm.noticeType[i] === 0) {
          this.isShowEmail = true;
          this.noticeType = this.elasticsearchWarningForm.noticeType;
          tableElasticsearchWarningVue.selectTemplate();
        }
        if (this.elasticsearchWarningForm.noticeType[i] === 1) {
          // this.isShowWeChat = true;
          this.noticeType = this.elasticsearchWarningForm.noticeType;
          this.checkLeastOnePersonBoundWeChat();
          tableElasticsearchWarningVue.selectTemplate();
        } else if (this.elasticsearchWarningForm.noticeType[i] !== 1) {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 检查至少有一人绑定过微信
    checkLeastOnePersonBoundWeChat: function () {
      for (
        var i = 0;
        i < this.elasticsearchWarningForm.noticeType.length;
        i++
      ) {
        if (this.elasticsearchWarningForm.noticeType[i] == 1) {
          var weChatDate = {
            contactType: this.elasticsearchWarningForm.contactType,
          };
          // 联系方式为 -联系人-
          if (this.elasticsearchWarningForm.contactType == 0) {
            weChatDate.userIds = this.elasticsearchWarningForm.userIdList;
          }
          // 联系方式为 -联系人组-
          else if (this.elasticsearchWarningForm.contactType == 1) {
            weChatDate.contactGroupIds =
              this.elasticsearchWarningForm.contactGroupIds;
          }
          this.$api.userWeChat
            .checkLeastOnePersonBoundWeChat(weChatDate)
            .then((res) => {
              if (res.data) {
                // 可以添加告警
                this.wechatWarningVisible = false;
                this.isAddOrEdit = false;
              } else {
                // 不可以添加微信告警
                this.wechatWarningVisible = true;
                this.isAddOrEdit = true;
              }
            });
        } else if (this.elasticsearchWarningForm.noticeType[i] != 1) {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 联系人组
    listContactGroups: function () {
      this.$api.contactGroup
        .listContactGroupsByAccountId(
          "accountId",
          this.elasticsearchWarningForm.account
        )
        .then((res) => {
          this.contactGroupIdList = res.data;
        });
    },
    // 切换联系人组
    changeContactGroupId: function () {
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换通知对象
    changeNotificationObject: function (val) {
      this.elasticsearchWarningForm.userIdList = [];
      this.elasticsearchWarningForm.notificationObject = val;
      for (
        var i = 0;
        i < this.elasticsearchWarningForm.notificationObject.length;
        i++
      ) {
        for (var j = 0; j < this.notificationObjectList.length; j++) {
          if (
            this.elasticsearchWarningForm.notificationObject[i] ==
            this.notificationObjectList[j].id
          ) {
            this.elasticsearchWarningForm.userIdList.push(
              this.notificationObjectList[j].userId
            ); //传值
          }
        }
      }
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换联系方式
    changeContactType: function () {
      this.checkLeastOnePersonBoundWeChat();
    },
    //点击查询 加载全部数据
    /***********************************************************************************/
    searchElasticsearchDate: function () {
      if (
        this.elasticsearchWarningForm.account == "" ||
        this.elasticsearchWarningForm.account == null ||
        this.elasticsearchWarningForm.backupRegion == "" ||
        this.elasticsearchWarningForm.backupRegion == null
      ) {
        return;
      }
      this.modal_loadings = true;
      // 根据AccountId查询es列表
      tableElasticsearchWarningVue.$api.elasticsearch
        .listEsByAccount({
          regions: this.elasticsearchWarningForm.backupRegion,
          accountId: this.elasticsearchWarningForm.account,
        })
        .then((res) => {
          this.tableElasticsearchDate = res.data;
          this.modal_loadings = false;
        });
    },

    /**************************************  查询  **************************************/
    // 查询监控指标
    searchMonitorIndex: function () {
      tableElasticsearchWarningVue.$api.alertRule
        .searchMonitorIndex({
          monitorModule: this.monitorModule,
          accountId: this.elasticsearchWarningForm.account,
        })
        .then((res) => {
          this.monitorIndexList = res.data;
        });
    },
    // 查询通知对象
    queryContacts: function () {
      tableElasticsearchWarningVue.$api.contact
        .queryContactsByAccountIdAndMonitorModule({
          monitorModule: this.monitorModule,
          accountId: this.elasticsearchWarningForm.account,
        })
        .then((res) => {
          this.notificationObjectList = res.data.contactList;
          this.elasticsearchWarningForm.notificationObject =
            res.data.defaultContactIds;
        });
    },
    // 查询报警方式
    alarmWay: function () {
      tableElasticsearchWarningVue.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmWayList = res.data;
        });
    },
    // 查询报警延迟
    getAlarmDelay: function () {
      tableElasticsearchWarningVue.$api.alertRule
        .alarmDelay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmDelayList = res.data;
        });
    },
    // 查询监控时间段
    searchMonitorPeriod: function () {
      this.$api.alertRule
        .monitorPeriod("userName", getCookie(global.cookieName))
        .then((res) => {
          this.monitorPeriodList = res.data;
        });
    },
    // 周期
    changeCycle: function () {
      // 查询阈值
      tableElasticsearchWarningVue.selectMonitorIndexDefault();
    },
    // 连续周期
    changeContinousCycle: function () {
      // 查询阈值
      tableElasticsearchWarningVue.selectMonitorIndexDefault();
    },
    // 统计数值
    changeStatisticsValue: function () {
      // 查询阈值
      tableElasticsearchWarningVue.selectMonitorIndexDefault();
    },
    // 关系符号
    changeRelationshipSign: function () {
      // 查询阈值
      tableElasticsearchWarningVue.selectMonitorIndexDefault();
      // 邮件模板
      tableElasticsearchWarningVue.selectTemplate();
    },
    // 根据用户名查询Account列表
    getAccount: function () {
      // 清空表格
      this.tableElasticsearchDate = [];
      tableElasticsearchWarningVue.$api.account
        .queryAccounts("userName", getCookie(global.cookieName))
        .then((res) => {
          this.accountList = res.data;
          for (var i = 0; i < this.accountList.length; i++) {
            this.accountList[i].name =
              this.accountList[i].name +
              "(" +
              this.accountList[i].accountTypeName +
              ")";
          }
        });
      // 查询方式
      tableElasticsearchWarningVue.alarmWay();
      // 查询报警延时
      tableElasticsearchWarningVue.getAlarmDelay();
      //监控时段
      tableElasticsearchWarningVue.searchMonitorPeriod();
      // 监控模块查询关联的机器人列表
      tableElasticsearchWarningVue.listEnterpriseWechatRobotsByMonitorModule();
    },
    // 监控模块查询关联的机器人列表
    listEnterpriseWechatRobotsByMonitorModule: function () {
      tableElasticsearchWarningVue.$api.enterpriseWechatRobot
        .listEnterpriseWechatRobotsByMonitorModule({
          monitorModule: this.monitorModule,
        })
        .then((res) => {
          this.enterpriseWechatRobotIdsList = res.data;
        });
    },
    // 选择账户
    changeAccount: function () {
      if (
        this.elasticsearchWarningForm.account == "" ||
        this.elasticsearchWarningForm.account == null
      ) {
        return;
      }
      this.elasticsearchWarningForm.backupRegion = "";
      // 清空表格
      this.tableElasticsearchDate = [];
      this.esList = [];
      this.isShowSearch = true;
      this.isNextClick = true;
      tableElasticsearchWarningVue.$api.account
        .queryAccountRegions("accountId", this.elasticsearchWarningForm.account)
        .then((res) => {
          this.backupRegionList = res.data;
        });
      // 查询通知对象
      tableElasticsearchWarningVue.queryContacts();
      // 查询联系人组
      tableElasticsearchWarningVue.listContactGroups();
    },
    /***********存储区域**************************/
    selectBackupRegionAll() {
      this.elasticsearchWarningForm.backupRegion = [];
      if (this.singleBackupRegion) {
        this.backupRegionList.map((item) => {
          this.elasticsearchWarningForm.backupRegion.push(item.name);
        });
      } else {
        this.elasticsearchWarningForm.backupRegion = [];
      }
    },
    // 切换存储区域
    changebackupRegion: function (val) {
      if (val.length === this.backupRegionList.length && val.length != 0) {
        this.singleBackupRegion = true;
      } else {
        this.singleBackupRegion = false;
      }
      // 表格数据为空、显示查询按钮、存储区域为空
      this.tableElasticsearchDate = [];
      this.esList = [];
      this.isShowSearch = true;
      this.isNextClick = true;
    },
    // 全选 单选
    /***********************************************************************************/
    // 单选
    selectChange(selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableElasticsearchDateList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableElasticsearchCopy = new Object();
        TableElasticsearchCopy.domainName = this.selection[i].domainName;
        TableElasticsearchCopy.accountId = this.selection[i].accountId;
        TableElasticsearchCopy.region = this.selection[i].region;
        this.newTableElasticsearchDateList.push(TableElasticsearchCopy);
      }
      // 选了数据 可以点击下一步
      if (this.newTableElasticsearchDateList.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 全选
    selectAll: function (selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableElasticsearchDateList = [];
      for (var i = 0; i < this.selection.length; i++) {
        // 状态
        var TableElasticsearchCopy = new Object();
        TableElasticsearchCopy.domainName = this.selection[i].domainName;
        TableElasticsearchCopy.accountId = this.selection[i].accountId;
        TableElasticsearchCopy.region = this.selection[i].region;
        this.newTableElasticsearchDateList.push(TableElasticsearchCopy);
      }
      if (this.selection.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 创建添加或编辑报警
    /**********************************************************************************/
    ok: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var alertList = {
            alertRuleName: this.elasticsearchWarningForm.ruleName,
            monitorIndex: this.elasticsearchWarningForm.monitorIndex,
            cycle: this.elasticsearchWarningForm.cycle,
            continousCycle: this.elasticsearchWarningForm.continousCycle,
            statisticsValue: this.elasticsearchWarningForm.statisticsValue,
            relationshipSign: this.elasticsearchWarningForm.relationshipSign,
            accountId: this.elasticsearchWarningForm.account,
            monitorModule: this.monitorModule,
            noticeType: this.elasticsearchWarningForm.noticeType,
            unit: this.units,
            delay: this.elasticsearchWarningForm.alarmDelay,
            monitorPeriod: this.elasticsearchWarningForm.monitorPeriod,
            thresholdValue: this.elasticsearchWarningForm.thresholdValue,
            contactType: this.elasticsearchWarningForm.contactType,
            enterpriseWechatRobotIds:
              this.elasticsearchWarningForm.enterpriseWechatRobotIds,
          };

          // 如果联系方式是联系人 传通知对象
          if (this.elasticsearchWarningForm.contactType == 0) {
            alertList.contactIDs =
              this.elasticsearchWarningForm.notificationObject;
          }
          // 如果联系方式是联系人组 传联系人组
          else if (this.elasticsearchWarningForm.contactType == 1) {
            alertList.contactGroupIds =
              this.elasticsearchWarningForm.contactGroupIds;
          }

          if (this.elasticsearchWarningForm.id > 0) {
            alertList.id = this.elasticsearchWarningForm.id;
            alertList.resourceEsDTOList = this.newTableElasticsearchDateList;
            // 编辑告警
            this.addloading = true;
            tableElasticsearchWarningVue.$api.alertRule
              .updateAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  this.elasticsearchWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success("编辑成功");
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowSearch = false;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          } else {
            // 添加告警
            this.addloading = true;
            alertList.resourceEsDTOList = this.newTableElasticsearchDateList;
            tableElasticsearchWarningVue.$api.alertRule
              .createAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  tableElasticsearch.methods.showAll();
                  this.elasticsearchWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success("添加成功");
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          }
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          if (this.elasticsearchWarningForm.id > 0) {
            this.$Message.error("编辑失败");
          } else {
            this.$Message.error("添加失败");
          }
        }
      });
    },
    // 取消
    cancel: function (name) {
      this.wechatWarningVisible = false;
      this.isAddOrEdit = true;
      this.isShowSearch = false;
      this.isShowEmail = false;
      this.isShowWeChat = false;
      this.isNextClick = true;
      this.modal = false;
      this.$emit("on-cancel");
      this.elasticsearchWarningForm.notificationObject = [];
      this.$nextTick(() => {
        this.$refs[name].resetFields();
      });
      // 清空表格
      this.tableElasticsearchDate = [];
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/es/AddOrUpdateElasticsearchWarning.vue